export const getTeaseIframeDimensions = state => state.tease.iframeDimensions || 0;
export const getFloatingIframeHeight = state => state.floating.iframeDimensions || 0;